export default "__VITE_ASSET__6X04xaKL__"